import React, { useContext } from 'react';
import { TouchableOpacity, StyleSheet, View, GestureResponderEvent } from 'react-native';
import { ActivityIndicator, Text, ThemeContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
function getStyles(theme: Theme) {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      padding: 18,
      borderBottomWidth: 1,
      borderColor: theme.colors.gray.light,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    firstContainer: {
      borderTopWidth: 1,
    },
    start: {
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
    },
    textContainer: {
      flex: 1,
      alignItems: 'flex-start',
    },
    label: {
      fontWeight: theme.font.weight.bold,
      fontSize: theme.font.size.regular,
      color: theme.colors.neutral,
      marginRight: 15,
    },
    value: {
      fontSize: theme.font.size.regular,
      color: theme.colors.neutral,
    },
    icon: {
      color: theme.colors.neutral,
      paddingRight: 18,
    },
  });
}

const TEXT_NUMBER_OF_LINES = 2;

export const ItemsPickerButton = (props: Props) => {
  const { children, iconName, label, value, labelStyle, onPress, first, isLoading, renderArrow, style } = props;

  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);
  const { IconComponent } = theme;

  const renderBody = () => {
    return (
      <View style={styles.start}>
        {iconName && <IconComponent name={iconName} size={22} style={styles.icon} />}
        {!!label && (
          <View style={styles.textContainer}>
            <Text numberOfLines={TEXT_NUMBER_OF_LINES} style={[styles.label, labelStyle]}>
              {label}
            </Text>
          </View>
        )}
        {!!value && (
          <View style={styles.textContainer}>
            <Text style={styles.value}>{value}</Text>
          </View>
        )}
      </View>
    );
  };

  const renderIcon = (isButtonEnabled: boolean) => {
    if (isButtonEnabled && !isLoading && renderArrow) {
      return renderArrow();
    } else if (isLoading && renderArrow) {
      return <ActivityIndicator />;
    }
  };

  const isButtonEnabled = !!onPress;

  return (
    <TouchableOpacity onPress={onPress} disabled={!isButtonEnabled || isLoading}>
      <View style={[styles.container, first && styles.firstContainer, style]}>
        {children ? children : renderBody()}
        {renderIcon(isButtonEnabled)}
      </View>
    </TouchableOpacity>
  );
};

type Props = {
  children?: any;
  first?: boolean;
  iconName?: string;
  isLoading?: boolean;
  label?: string;
  labelStyle?: Record<string, any>;
  onPress?: (event: GestureResponderEvent) => void;
  renderArrow?: Function;
  value?: string;
  style?: Record<string, any>;
};
